var React = require('react');

function InstagramInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#fff","key":0}),React.createElement("rect",{"x":"8.25","y":"8.25","width":"15.5","height":"15.5","rx":"3.88","strokeWidth":"2","stroke":"#003c61","strokeLinecap":"round","strokeLinejoin":"round","fill":"none","key":1}),React.createElement("path",{"d":"M19.1,15.51a3.1,3.1,0,1,1-3.52-2.61,3.47,3.47,0,0,1,.91,0A3.1,3.1,0,0,1,19.1,15.51Z","fill":"none","stroke":"#003c61","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":2}),React.createElement("circle",{"cx":"20.26","cy":"11.37","r":"1","fill":"#003c61","key":3})]);
}

InstagramInline.defaultProps = {"id":"Calque_1","data-name":"Calque 1","viewBox":"0 0 32 32"};

module.exports = InstagramInline;

InstagramInline.default = InstagramInline;
